module.exports = __webpack_public_path__ + "static/media/year2020_11-tc.7bfdda3b.jpg";